module.exports = __webpack_public_path__ + "static/media/sky.134967f5.jpg";